import { Route } from "react-router-dom";
import { ShowProvider } from "../../../providers";
import { PushAnalyticsList } from "../PushAnalytics-List/PushAnalytics-List";
import { StatsPushesList } from "../StatsPushes-List/StatsPushes-List";

const statsPushesRoutes = [
  <Route
    key={"statsPushes"}
    path="statsPushes"
    element={<ShowProvider>{<StatsPushesList />}</ShowProvider>}
  />,
  <Route
    key={"pushAnalytics"}
    path="pushAnalytics"
    element={<ShowProvider>{<PushAnalyticsList />}</ShowProvider>}
  />,
];

export const STATS_PUSHES_ROUTES = statsPushesRoutes.map((route) => route);
